<template>
  <div
    :class="[$x.container, { [$x.productDetail]: productDetail }]"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/Offer"
  >
    <!-- ---------- -->
    <!-- LEFT PRICE -->
    <!-- ---------- -->

    <!-- LEFT LABEL (SHOWN WHEN ADR) -->
    <span v-if="showAdr && priceLabel" :class="$x['label']">{{
      priceLabel
    }}</span>

    <!-- PRICE -->
    <NsCurrency
      :class="[
        $x['price'],
        { [$x['strike-through']]: showOriginalCrossedOut && !showAdr }
      ]"
      :amount="leftPrice"
      itemprop="price"
      data-testid="left-price"
    />

    <!-- --------- -->
    <!-- SEPARATOR -->
    <!-- --------- -->

    <span v-if="showDash || showAdr" :class="$x['price-separator']">
      {{ showDash ? "-" : showAdr && "•" }}
    </span>

    <!-- ----------- -->
    <!-- RIGHT PRICE -->
    <!-- ----------- -->

    <!-- RIGHT LABEL (SHOWN WHEN ADR) -->
    <span v-if="showAdr && adrPriceLabel" :class="$x['label']">{{
      adrPriceLabel
    }}</span>

    <!-- PRICE -->
    <NsCurrency
      v-if="showRightPrice"
      :class="$x['price']"
      :amount="rightPrice"
      itemprop="price"
      data-testid="right-price"
    />
  </div>
</template>

<script>
import NsCurrency from "./NsCurrency.vue";

export default {
  name: "NsProductPrice",
  components: { NsCurrency },
  props: {
    adrPrice: {
      type: String,
      default: ""
    },
    adrPriceLabel: {
      type: String,
      default: ""
    },
    isBaseSku: Boolean,
    minPrice: {
      type: String,
      default: ""
    },
    maxPrice: {
      type: String,
      default: ""
    },
    originalPrice: {
      type: String,
      default: ""
    },
    price: {
      type: String,
      default: ""
    },
    priceLabel: {
      type: String,
      default: ""
    },
    productDetail: Boolean,
    saleActive: Boolean,
    showOriginalCrossedOut: Boolean,
    /**
     * Force showing the ADR price
     */
    showAdrPrice: Boolean,
    /**
     * Override hiding all components associated with ADR
     */
    hideAdrOverride: Boolean
  },
  computed: {
    leftPrice() {
      if (this.isBaseSku) {
        return this.minPrice;
      } else if (
        !this.showAdr &&
        (this.showOriginalCrossedOut || this.saleActive)
      ) {
        return this.originalPrice;
      } else {
        return this.price;
      }
    },
    rightPrice() {
      if (this.isBaseSku) {
        return this.maxPrice;
      } else if (this.showAdr) {
        return this.adrPrice;
      } else {
        return this.price;
      }
    },
    showRightPrice() {
      return (this.isBaseSku && this.minPrice !== this.maxPrice) ||
        this.showAdr ||
        this.saleActive ||
        this.showOriginalCrossedOut
        ? true
        : false;
    },
    showDash() {
      return this.isBaseSku && this.minPrice !== this.maxPrice;
    },
    showAdr() {
      return (
        !this.hideAdrOverride &&
        this.adrPrice &&
        (this.showAdrPrice || this.adrPrice !== this.price)
      );
    }
  }
};
</script>
<style module></style>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.container {
  position: relative;
  display: flex;
  justify-content: center;
  @extend .p-medium;
}

.price {
  position: relative;
  display: inline-block;
  font-weight: map-get(typographyVariables.$typography, font-weight-semibold);

  &.strike-through {
    margin-right: 20px;
    color: map-get(colors.$themeColors, color-interactive-8);
    font-weight: map-get(typographyVariables.$typography, font-weight-regular);
    text-decoration: line-through;
  }
}

.label {
  margin: 0;
  margin-right: 6px;
}

.price-separator {
  margin: 0 10px;
}
@media (min-width: 768px) {
  .container.productDetail {
    justify-content: flex-start;
  }
}
</style>
